var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.333496C9.31371 0.333496 12 2.99065 12 6.26841C12 8.4374 10.1851 10.7307 6.63217 13.2289L6 13.6668L5.61853 13.4036C1.90028 10.8374 0 8.48784 0 6.26841C0 2.99065 2.68629 0.333496 6 0.333496ZM6 1.65236C3.42267 1.65236 1.33333 3.71904 1.33333 6.26841C1.33333 7.87006 2.86448 9.82446 6 12.0547C9.13552 9.82446 10.6667 7.87006 10.6667 6.26841C10.6667 3.71904 8.57733 1.65236 6 1.65236ZM6 3.00016C7.47276 3.00016 8.66667 4.19407 8.66667 5.66683C8.66667 7.13959 7.47276 8.3335 6 8.3335C4.52724 8.3335 3.33333 7.13959 3.33333 5.66683C3.33333 4.19407 4.52724 3.00016 6 3.00016ZM6 4.3335C5.26362 4.3335 4.66667 4.93045 4.66667 5.66683C4.66667 6.40321 5.26362 7.00016 6 7.00016C6.73638 7.00016 7.33333 6.40321 7.33333 5.66683C7.33333 4.93045 6.73638 4.3335 6 4.3335Z",
    fill: "#EA580C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.17fa9a3a.svg";
export { ForwardRef as ReactComponent };